<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[rateCeilings$]"></ef-loading-container>
<ef-rate-ceiling-presenter
    [rateCeilings]="rateCeilings$ | async"
    [contracts]="contracts$ | async"
    [chargeNumbers]="chargeNumbers$ | async"
    [costCenters]="costCenters$ | async"
    [userInfo]="userInfo$ | async"
    [process]="process$ | async"
    (DeleteRateCeiling)="onDeleteRateCeiling($event)"
    (SaveRateCeiling)="onSaveRateCeiling($event)"
    (AddRateCeiling)="onAddRateCeiling($event)"
    (LoadChargeNumbers)="onLoadChargeNumbers($event)"
    (IncludeInactiveChecked)="onIncludeInactiveChecked($event)"
>
</ef-rate-ceiling-presenter>
